export type ClipType = 'photo' | 'video' | 'document' | 'audio' | 'non-media';

export const MAX_CLIPS_PER_REQUEST = 25;
export const MAX_VIDEOS_PER_REQUEST = 5;
// biome-ignore lint/style/noMagicNumbers: this is 100MB, no need another constant
export const MAX_VIDEO_SIZE_BYTES = 100 * 1024 * 1024; // 100MB — larger files risk OOM in the Vercel function
export const ENTERPRISE_PLANS = new Set(['enterprise', 'demo']);

/** Delay before redirecting to the Shopify product page after a successful delivery */
export const REDIRECT_TO_SHOPIFY_DELAY_MS = 2000;

export type DeliverableClip = {
  id: string;
  assetId: string;
  type: ClipType;
  assets: {
    /** Imgix URL — fallback only */
    image: string;
    /** Direct CDN URL — preferred source for signing */
    original?: string;
    /** HLS stream — NOT usable for Shopify uploads, use original */
    video?: string;
  };
  /** Maps to Shopify alt text */
  description?: string;
  name?: string;
  ext?: string;
  /** MIME type — used for video staged upload */
  mime?: string;
  /** File size in bytes — required by stagedUploadsCreate for VIDEO uploads */
  size?: number;
};

export type ShopifyDeliverErrorReason = 'unsupported_type' | 'upload_failed' | 'plan_required' | 'file_too_large';

/** Single-clip response from /api/shopify/deliver */
export type ShopifyDeliverClipResponse =
  | { ok: true; shopifyMediaGid: string }
  | { ok: false; reason: ShopifyDeliverErrorReason };

/** Accumulated result across all clips — used by the store and hook return value */
export type ShopifyDeliverResponse = {
  initiated: {
    airClipId: string;
    shopifyMediaGid: string;
  }[];
  errors: {
    airClipId: string;
    reason: ShopifyDeliverErrorReason;
  }[];
};
